/**
* 馨康宝
*
* @author 张毅
*
*/

<template>
	<div class="registerwithsms" ref="schema" v-if="draw">
		<van-cell-group inset class="card" :border="false">
			<van-cell class="title" title="健康调查" :border="false"/>
			<van-cell class="form">
				<template #title>
					<van-form class="body" @submit="submit" label-width="3rem">
						<van-field
                left-icon="phone-o"
                v-model="mobile"
                name="mobile"
                :rules="rules"
                placeholder="请输入手机号"
            />
						<van-field
                left-icon="shield-o"
                v-model="crc"
                name="crc"
                maxlength="6"
                placeholder="请输入验证码"
							:right-icon="crc && /\d{6}/.test(crc) ? ( verify ? 'checked' : 'clear') : ''">
              <template #button>
                <van-button
                    class="my-button-yan"
                    style="color: #33c0b2"
                    @click="getCrc"
                    color="#33c0b2"
                    size="mini"
                    plain
                    native-type="button"
                    :disabled="timer > 0">
                  获取验证码{{ timer > 0 ? '【' + timer + '】' : '' }}
                </van-button>
              </template>
						</van-field>
						<div style="margin: 16px;">
							<van-checkbox v-model="agree" shape="square" label-disabled icon-size="14px"
								checked-color="#0066B4">
								<font size="1">同意</font>
								<span @click="showService = true" style="font-size: small;">
									<font color="#06b7a3">《用户服务协议》</font>
								</span>
								<font size="1">和</font>
								<span @click="showLicense = true" style="font-size: small;">
									<font color="#06b7a3">《保密政策协议》</font>
								</span>
							</van-checkbox>
						</div>
						<div style="margin: 40px 16px 0px 16px">
							<van-button block color="#06b7a3" round native-type="submit" :disabled="!agree">登录</van-button>
						</div>
					</van-form>
				</template>
			</van-cell>
		</van-cell-group>
		<div class="support">
			技术支持：青岛海鲲蓝宇科技有限公司
		</div>
		<van-popup v-model="showLicense" position="bottom" closeable close-icon="close">
			<h4 class="text-center">用户隐私政策</h4>
			<UserLicense />
		</van-popup>
		<van-popup v-model="showService" position="bottom" closeable close-icon="close">
			<h4 class="text-center">用户服务协议</h4>
			<user-service />
		</van-popup>
	</div>
	<Loading v-else></Loading>
</template>

<script>
	import Loading from '../libs/Loading.vue';
	import Licence from "../License.vue";
	import UserLicense from "~/user/UserLicense";
	import UserService from "~/user/UserService";
	export default {
		name: 'RegisterWithSms',
		components: {
			Loading,
			Licence,
			UserLicense,
			UserService
		},
		data() {
			return {
				agree: false,
				draw: false,
				wexinLogonUser: {},
				mobile: undefined,
				crc: '',
				verify: false,
				timer: 0,
				loading: false,
				showLicense: false,
				showService: false,
				rules: [{
						required: true,
						message: '手机号不能为空值'
					},
					{
						validator: this.checkMobile,
						message: '由11位以 [13/14/15/17/18/19] 开头的数字组成，且必须是唯一的'
					}
				]
			}
		},
		methods: {
			checkMobile: function() {
				var regex = new RegExp('^1[3|4|5|7|8|9][0-9]{9}$');
				return regex.test(this.mobile);
			},
			getCrc: async function() {
				this.verify = false;
				this.crc = '';
				var b = this.checkMobile();
				if (b) {
					await this.$axios.get('/api/signin/loginCRC' + '/' + this.mobile);
					this.timer = 60;
					var interval = setInterval(() => {
						this.timer--;
						if (this.timer <= 0) {
							clearInterval(interval);
						}
					}, 1000)
				}
			},
			verifyCrc: async function() {
				if (!this.crc || !/\d{6}/.test(this.crc)) {
					this.verify = false;
					return;
				}
				var response = await this.$axios.get('/api/signin/loginCRCValidity' + '/' + this.mobile + '/' +
					this.crc);
				this.verify = response.data || false;
			},
			submit: async function() {
				try {
					if (!this.agree) {
						this.$toast('请先查看并同意《用户服务协议》和《用户隐私政策》');
						return;
					}
					await this.verifyCrc();
					if (!this.verify) {
						this.$notify('验证码错误');
						return;
					}
					var exist = await this.$axios.post('/api/signin/userExistedMobile', {
						mobile: this.mobile
					});
					if (!exist.data) {
						await this.$axios.post('/api/signin/newUserWithSms/' + this.mobile);
					}
					try {
						var login = await this.$axios.get('/api/signin/login/roles');
						var response = await this.$axios.post('/api/signin/smsLoginNotice', {
							mobile: this.mobile,
							crc: this.crc,
							roles: login.data.roles
						});
						if (response.data.state === 'success') {
							sessionStorage.setItem('Authorization-Token', response.data.token);
							await this.$parent.checkLogonUser();
							this.$parent.switchToStarter();
						} else {
							this.$notify(response.data.msg);
						}
					} catch (error) {
						this.$notify(error.message);
					}
				} catch (error) {
					this.$notify('登录失败');
					this.mobile = '';
					this.crc = '';
				}
			}
		},
		mounted: function() {
			this.draw = true;
		},
		watch: {
			crc() {
				this.verifyCrc();
			},
			mobile() {
				this.verifyCrc();
			}
		}
	}
</script>

<style scoped>
	.registerwithsms {
		min-height: 650px;
		height: 100%;
		position: relative;
		/*background-image: url(../assets/bg-portrait.jpg);*/
		background-size: 100% 100%;
	}

  /deep/.my-button-yan {
    color: #33c0b2;
    border: 0px solid #ebedf0;
  }

	.registerwithsms .card {
		top: 150px;
    position: inherit;
		margin: 0 0px;
		width: auto;
		background-color: rgba(255, 255, 255, .4);
	}

	.registerwithsms .card:after {
		border-bottom: none;
	}

	.registerwithsms .card>.van-cell {
		background-color: rgba(255, 255, 255, .4);
	}

	.registerwithsms .card>.van-cell:after {
		border-bottom: none;
	}

	.registerwithsms .card>.title .van-cell__title {
		text-align: center;
		font-weight: 700;
		font-size: 20px;
		padding-top: 20px;
		color: #B44E28;
	}

	.registerwithsms .card>.form .van-form>.van-cell {
		background-color: transparent;
	}

	.registerwithsms .card>.form .van-form>.van-cell::after {
		border-color: #5B96A4;
	}

	.registerwithsms .card>.form .van-form>.van-field {
		align-items: center;
	}

	.registerwithsms .card>.form .van-form .van-checkbox .van-icon {
		border-color: #000000;
	}

	.registerwithsms .support {
		position: absolute;
		bottom: 0;
		width: 100%;
		text-align: center;
		color: #FFFFFF;
		background-color: rgba(0, 0, 0, .7);
		padding: 10px 0;
		font-size: 12px;
	}

	.registerwithsms .van-popup {
		height: 100%;
	}

	.registerwithsms .van-popup .van-cell-group {
		height: calc(100% - 100px);
	}
</style>



// WEBPACK FOOTER //
// src/login/Login.vue